var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import ConfigurationComponent from './base/ConfigurationComponent';
var ChartYAxisItem = function (props) {
    return (React.createElement(ConfigurationComponent, __assign({}, props)));
};
ChartYAxisItem.displayName = 'ChartYAxisItem';
export default ChartYAxisItem;
//# sourceMappingURL=YAxisItem.js.map